import React from 'react';

/**
 * @param {string} [separator='›'] Single character between crumbs; spaces are added either side.
 */
const BreadCrumbs = ({ children, className, separator = '›', ...rest }) => {
  let idx = 0;

  return (
    <div className={className ? className : null} {...rest}>
      {children.map((elem) => {
        if (!elem) {
          return '';
        }

        return idx++ === 0 ? (
          <span key={`breadcrumb_${idx}`}>{elem}</span>
        ) : (
          <span key={`breadcrumb_${idx}`}>
            <span aria-hidden="true">{` ${separator} `}</span>
            {elem}
          </span>
        );
      })}
    </div>
  );
};

export default BreadCrumbs;
